// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"


var jQuery = require('jquery')
// include jQuery in global and window scope (so you can access it globally)
// in your web browser, when you type $('.div'), it is actually refering to global.$('.div')
global.$ = global.jQuery = jQuery;
window.$ = window.jQuery = jQuery;
import 'jquery.appear';
import 'slick-carousel';

// Import Bootstrap and Popper.js
import 'bootstrap';
import '@popperjs/core'; // Popper.js is required for Bootstrap's JavaScript components
import '../custom/partners';
import '../custom/slider';
Rails.start()